:host {
	display: inline-block;

	// Default size of 'md'
	font-size: 24px;
	vertical-align: text-top;
}

.zds-icon {
	display: block;

	svg {
		display: block;
		fill: currentcolor;
		height: auto;
		width: auto;
	}

	// Set the icon's dimensions to em to make sure the icon size adheres to the given font-size
	&:not(&--sizing-type-width) {
		height: 1em;

		svg {
			height: 100%;
		}
	}

	&:not(&--sizing-type-height) {
		width: 1em;

		svg {
			width: 100%;
		}
	}
}

.zds-icon__missing {
	background-color: currentcolor;
	height: 100%;
	width: 100%;
}

:host([size='xxs']) {
	font-size: 12px;
}

:host([size='xs']) {
	font-size: 16px;
}

:host([size='sm']) {
	font-size: 20px;
}

// Default size 'md' is 24px

:host([size='lg']) {
	font-size: 32px;
}

:host([size='xl']) {
	font-size: 40px;
}

:host([size='xxl']) {
	font-size: 48px;
}

:host([size='inherit']) {
	font-size: inherit;
}
